import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraVersion } from '@/types/Bera';

export interface GetBeraVersionListParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = BeraV2Service.getInstance();

export function useGetBeraVersionList(params: GetBeraVersionListParams) {
	const enabled = validateUuid([params.organization_id, params.company_id, params.id]);

	return useQuery<BeraVersion[]>({
		queryKey: [QUERY_KEYS.GET_BERA_VERSION_LIST, params],
		queryFn: async () => Service.listVersions(params),
		enabled,
		retry: 0
	});
}
